import { BenchmarkDataAction } from './actions'
import { BenchmarkInfo } from './types'

export interface State {
  benchmarkInfo?: BenchmarkInfo
  pending: boolean
  error: boolean
  securitySearch: { [gridIndex: number]: string }
}

export const initialState: State = {
  benchmarkInfo: undefined,
  pending: true,
  error: false,
  securitySearch: {}
}

export default (state = initialState, action: BenchmarkDataAction): State => {
  switch (action.type) {
    case 'benchmarkdata.success':
      return {
        ...state,
        benchmarkInfo: action.payload,
        error: false,
        pending: false
      }

    case 'benchmarkdata.fetch':
      return {
        ...state,
        pending: true,
        benchmarkInfo: undefined,
        error: false
      }

    case 'benchmarkdata.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'benchmarkdata.setSecuritySearch':
      return {
        ...state,
        securitySearch: {
          ...state.securitySearch,
          [action.payload.gridIndex]: action.payload.search
        }
      }
    default:
      return state
  }
}
